module.exports = __webpack_public_path__ + "static/img/17.3d14a61e.png";